import React from 'react';

export default class Page1 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="ilead-rgt task">
                                <div className="innerpadding">
                                    <div className="innovativeimg">
                                        <img alt=""
                                             src={require('@images/How to cope with setbacks.png')}/>
                                    </div>

                                    <div className="ilead-contentarea">

                                        <div className="circle_title"><img
                                            src={require('@images/Browndot.png')}
                                            alt=""/>isn't it interesting?
                                        </div>
                                        <p>At one time or another, we all come across the proverbial ‘brick
                                            wall’. Do you tend to bang your
                                            head fruitlessly, or do you navigate yourself around it
                                            successfully?</p>


                                        <div className="border_subtitle">How hardy are you?</div>
                                        <div className="paraspace"><p>Darwin’s theory of ‘natural selection’
                                            explains that only the most hardy and adaptive of plant and
                                            animal life survives. The same logic (if less dramatic) can be
                                            applied to working life too. The study
                                            below describes the culmination of 30 years of research into the
                                            skills and attitudes needed to
                                            overcome setbacks and work past the wall.</p></div>

                                        <div className="lightgreencontentbg keyquestionpad ">
                                            <div className="border_subtitle">How hardy are you?</div>
                                            <p className="supLinesapce">In the late 1970s, psychologists Suzanne
                                                Kobasa<a className="superscripttext "
                                                         href="further_info.php?course=300"><sup>1</sup></a> and
                                                colleagues undertook a long-term
                                                research study into the impact of stress on a large
                                                organisation’s senior executives during
                                                its break-up. The executives were either being moved to other
                                                roles or departments or
                                                were losing their jobs entirely.</p>
                                            <p>Over this period, the team found two broad ways in which the
                                                executives reacted to the
                                                news. On one side, employees became increasingly distressed,
                                                developing psychological
                                                and physiological ailments. Conversely, the other group
                                                demonstrated few or no medical
                                                symptoms. In fact, they seemed to rise to the challenge,
                                                becoming more healthy and robust
                                                in the process.</p>
                                            <p>So what factors led some employees to crumble and some to thrive?
                                                The researchers put
                                                this down to the concept of hardiness – a particular pattern of
                                                attitudes and skills that
                                                helps you to be resilient, thrive under stress and cope with
                                                setbacks.</p>
                                            <div className="uiheading	"><p>Perhaps most importantly, though,
                                                whereas under Darwin’s theory we either have the
                                                genes to survive or not, Kobasa’s research suggests that we can
                                                actually develop the skills
                                                and attitudes needed to enhance our ability to deal with what
                                                life throws at us.</p></div>
                                        </div>


                                        <div className="right-btn">
                                            <div
                                                onClick={this.props.handleChangePage('Page2')}
                                                className="button-next-previous-done task">Next &gt;&gt;</div>
                                        </div>

                                    </div>

                                </div>


                            </div>


                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}